import { render, staticRenderFns } from "./flights-suggestions.vue?vue&type=template&id=938c6db4"
import script from "./flights-suggestions.vue?vue&type=script&lang=js"
export * from "./flights-suggestions.vue?vue&type=script&lang=js"
import style0 from "./flights-suggestions.vue?vue&type=style&index=0&id=938c6db4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports